import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IFilterSheetsState } from "./definitions";

const initialState: IFilterSheetsState = {
    isOpen: false,
    filtersMap: new Map<string, any>(),
};

const filterSheetsSlice = createSlice({
    name: "filterSheets",
    initialState,
    reducers: {
        setFilterSheetsOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        updateFilterMap: (state, action: PayloadAction<Map<string, any>>) => {
            state.filtersMap = action.payload;
        },
    },
});

export const { setFilterSheetsOpen, updateFilterMap } = filterSheetsSlice.actions;
export const filterSheetsReducer = filterSheetsSlice.reducer;
export default filterSheetsSlice.reducer;
